import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-two-factor-auth',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './two-factor-auth.component.html',
  styleUrl: './two-factor-auth.component.css'
})
export class TwoFactorAuthComponent {
  @Input() selected2FA: string = 'email';
  @Output() twoFAChange = new EventEmitter<'email' | 'sms' | 'voice'>();

  on2FAChange(method: 'email' | 'sms' | 'voice', event: Event) {
    event.preventDefault();
    this.twoFAChange.emit(method);
  }
}
